<template>
  <div class="currency-list">
    <el-table :data="bindCurrencies">
      <el-table-column
        label="-"
        width="50">
        <template slot-scope="scope">
          <currency-controls :currency="scope.row" @remove="bindCurrencies.splice(bindCurrencies.indexOf($event), 1)" leftControl />
        </template>
      </el-table-column>
      <el-table-column label="Name" prop="name" />
      <el-table-column label="Rate" prop="rate" />
      <el-table-column
        fixed="right"
        width="240">
          <template slot-scope="scope">
            <currency-controls :currency="scope.row" @update="updateCurrency" />
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
import CurrencyControls from './CurrencyControls'

export default {
  name: 'CurrencyList',
  components: { CurrencyControls },
  props: {
    currencies: {
      type: Array,
      required: true
    }
  },
  watch: {
    currencies () {
      this.bindCurrencies = this.currencies
    }
  },
  data () {
    return {
      bindCurrencies: this.currencies
    }
  },
  methods: {
    updateCurrency (currency, updated) {
      const index = this.bindCurrencies.indexOf(currency)
      this.bindCurrencies[index].name = updated.name
      this.bindCurrencies[index].rate = updated.rate
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/currencies/CurrencyList.vue